import { autoserialize, autoserializeAs } from 'cerialize';
import { Tenant } from './tenant';

export class UserTenancy {
  @autoserialize
  userId: number;

  @autoserializeAs(Tenant)
  tenant: Tenant;
}
